import { render, staticRenderFns } from "./CreateDTE.vue?vue&type=template&id=522cbc76&scoped=true&"
import script from "./CreateDTE.vue?vue&type=script&lang=js&"
export * from "./CreateDTE.vue?vue&type=script&lang=js&"
import style0 from "./CreateDTE.vue?vue&type=style&index=0&id=522cbc76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522cbc76",
  null
  
)

export default component.exports